
export const formatEmailDisplay = (email: string | null | undefined): string => {
  if (!email) {
    return 'Engramiq';
  }
  
  if (email.toLowerCase().endsWith('@engramiq.com')) {
    return 'Engramiq';
  }
  
  return email;
};
